import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { fetchAccessPoints } from 'store/actions/accessPoints/fetchAccessPoints';
import LoadingCard from 'components/loading/LoadingCard';
import ProductAccessPointsList from './ProductAccessPointsList';
import translate from 'components/hoc/translate';

class ProductAccessPointsContainer extends Component {
    componentDidMount() {
        const { fetchProductAccessPoints } = this.props;

        fetchProductAccessPoints();
    }

    render() {
        const { id, accessPoints, loading, resource } = this.props;

        if (loading) {
            return <LoadingCard />;
        }

        return (
            <ProductAccessPointsList productId={ id } accessPoints={ accessPoints } resource={ resource } />
        );
    }
}

ProductAccessPointsContainer.propTypes = {
    accessPoints: PropTypes.object,
    fetchProductAccessPoints: PropTypes.func,
    id: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    resource: PropTypes.string,
};

const mapStateToProps = (state, props) => {
    const { resource } = props;

    return {
        accessPoints: state[resource].data,
        loading: state[resource].loading,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        fetchProductAccessPoints: () => {
            dispatch(fetchAccessPoints({
                product_id: props.id,
            }));
        },
    };
};

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    translate,
);

export default enhance(ProductAccessPointsContainer);


// WEBPACK FOOTER //
// ./src/pages/products/productAccessPoints/ProductAccessPointsContainer.js